// BRACKET EVENT IDS
export const playoffEventIdsDev = {
  //QUARTERS
  q1: 415,
  // q2: 224,
  q2: 416,
  //SEMIS
  s1: 420,
  s2: 419,
  //CHAMP
  c: 421,
}

// BRACKET EVENT IDS
export const playoffEventIdsProd = {
  //QUARTERS
  q1: 375,
  // q2: 224,
  q2: 376,
  //SEMIS
  s1: 380,
  s2: 379,
  //CHAMP
  c: 381,
}

export const playoffEventIds =
  process.env.NODE_ENV === 'development' ? playoffEventIdsDev : playoffEventIdsProd
